<template>
  <div id="cableView">
	  <div class="location_wrap">
		<strong v-for="(location, idx) in locations" :key="`location_${idx}`"
			:class="['location_item paint', {'active': location.key === search}]"
			@click.prevent="filter(location.key)"> 
			{{location.text}} 
		</strong>
	</div>
	<article class="cable_table">
		<div class="column_box">
			<em class="cell1 column"> 지역 </em>
			<em class="cell2 column"> 상세지역 </em>
			<em class="cell3 column"> 방송사 </em>
			<em class="cell4 column"> 케이블 </em>
			<em class="cell5 column"> 디지털SD </em>
			<em class="cell6 column"> 디지털HD </em>
		</div>
		<div class="cable_no_data" v-if="filtered == 0">
			<p> 서비스 준비 중입니다. </p>
		</div>
		<div class="row_box" v-for="row in filtered" :key="row.id">
			<p class="cell1 row"> {{ row.location }} </p>
			<p class="cell2 row"> {{ row.location2 }} </p>
			<p class="cell3 row"> {{ row.broadcast }} </p>
			<p class="cell4 row"> {{ row.cable_num }} </p>
			<p class="cell5 row"> {{ row.sd_num }} </p>
			<p class="cell6 row"> {{ row.hd_num }} </p>
		</div>
	</article>
  </div>
</template>

<script>
import * as Store from '@/store/modules/cable'
export default {
	name: "cable",
	data() {
		return {
			search: null,
			locations: [
				{text: '서울', key: '서울'},
				{text:'인천/경기', key: '인천/경기'},
				{text:'부산/울산/경남', key: '부산/울산/경남'},
				{text:'대구/경북', key: '대구/경북'}, 
				{text:'대전/충청/세종', key: '대전/충북/충남/세종'},
				{text:'광주/전라', key: '광주/전남/전북'},
				{text:'강원/제주', key: '강원/제주'}
			],
			filtered: []
		}
	},
	computed: {
		...Store.mapState(['cables']),
		rows() { return this.cables},
		columns() { return  _.groupBy(this.rows, 'location') },
	},
	async created() {
		await this.getCables()
		this.filter(this.locations[0].key)
	},
	methods: {
		...Store.mapActions(['getCables']),
		filter(location) {
			let temp = []
			location.split("/").forEach(v => {
				if(_.has(this.columns, v)) {
					temp = temp.concat(this.columns[v])
				}
			})
			this.search = location
			this.$set(this,'filtered', temp)
			// console.log(this.filtered)
		}
  	}
}
</script>
<style lang="less">
#cableView { 
	width: 100%;
	margin-top: 55px;
	min-height: 500px;
	.location_wrap {
		display: flex;
		flex-flow: row wrap;
		margin-bottom: 20px;
		.location_item {
			text-align: center;
			flex: 1 1 auto;
			font-size: 22px;
			font-weight: bold;
			color: #ff6400;
			opacity: 0.5;
			cursor: pointer;
			-webkit-tap-highlight-color: transparent;
			&.active {
				opacity: 1;
			}
		}
	}
	.cable_table {
		display: flex;
		flex-flow: column wrap;
		transform: skew(-0.05deg);
		.cell1 { order:1; flex: 1 1 0;}
		.cell2 { order:2; flex: 3 1 0;}
		.cell3 { order:3; flex: 4 1 0;}
		.cell4 { order:4; flex: 1 1 0;}
		.cell5 { order:5; flex: 1 1 0;}
		.cell6 { order:6; flex: 1 1 0; }

		.cable_no_data {
			width: 100%;
			height: 298px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 17px;
			color: #8F8F8F;
			font-weight: 400;
			border-bottom: 1px solid rgba(143, 143, 143, 0.3);
		}
		.column_box {
			display: flex;
			flex-flow: row wrap;
			background-color: #ff6400;
			height: 39px;
			border: none;
			.column {
				display: flex;
				flex-flow: row wrap;
				justify-content: center;
				align-items: center;
				color: #FFFFFF;
				font-size: 17px;
				font-weight: 600;
				border: 1px solid #ff6400;
			}
		}
		.row_box {
			display: flex;
			flex-flow: row wrap;
			justify-content: center;
			align-items: center;
			min-height: 60px;
			border-bottom: 1px solid rgba(143, 143, 143, 0.3);
			margin: 0 8px;
			.row {
				color: #8F8F8F;
				display: flex;
				flex-flow: row wrap;
				justify-content: center;
				align-items: center;
				font-size: 17px;
				font-weight: 400;
				text-align: center;
			}
		}
	}
}

.m #cableView {
	.location_wrap {
		justify-content: space-between;
		.location_item {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 30px;
			font-size: 28px;
			margin-bottom: 30px;
			&:nth-child(5) {
				margin-left: 20px;
			}
			&:nth-child(7) {
				margin-right: 20px;
			}
		}
	}
	.cable_table {
		.cell1 { order:1; flex: 1 1 0;}
		.cell2 { order:1; flex: 2 1 0;}
    // .cell2 { display: none;}
		.cell3 { order:3; flex: 3 1 0;}
		.cell4 { order:4; flex: 1 1 0;}
		.cell5 { order:5; flex: 1 1 0;}
		.cell6 { order:6; flex: 1 1 0; }

		.cable_no_data {
			height: 362px;
			color: #717171;
			font-size: 24px;
		}
		.column_box {
			height: 60px;
			.column { 
				font-size: 18px;
			}
		}
		.row_box {
			margin: 0;
			.row {
				font-size: 20px;
			}
		}
	}
}
</style>